<template>
  <div class="mb-3">
    <label>
      {{ field.name }}
      <span class="text-danger" v-if="field.required">*</span>
      <span class="text-error" v-if="field.validation"
        >Please Select At Least One Information.</span
      ></label
    >
    <b-form-checkbox-group :name="`cb-${index}`" stacked>
      <b-form-checkbox
        v-for="(choice, i) in field.field_choices"
        :key="i"
        :value="choice.name"
        :disabled="statusCampaign != 0 && field.field_profile_type_id != 0"
        v-model="field.value"
        >{{ choice.name }}</b-form-checkbox
      >
    </b-form-checkbox-group>
  </div>
</template>

<script>
export default {
  name: "FieldCheckbox",
  props: {
    field: {
      required: true,
      type: Object,
    },
    statusCampaign: {
      required: true,
      type: Number,
    },
    index: {
      required: true,
      type: Number,
    },
  },
};
</script>

<style lang="scss" scoped>
.text-error {
  color: #ff0000;
  font-size: 14px !important;
  font-weight: normal !important;
}
label {
  color: var(--font-main-color) !important;
  font-size: 16px;
  margin-bottom: 2px;
  font-weight: bold;
}
</style>
